import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { formatearMonto } from '../../helpers/helper'
import GenericSelect from '../../reutilizables/genericSelect/GenericSelect'
import { buscarUnidad } from '../../servicios/publicacionesService'
import Input from '../../ui/Input'
import InputLabel from '../../ui/InputLabel'
import styles from './CambioPrecio.module.css'

const MAX_PORC_CAMBIO = 99
const PRECIO_MAYORISTA_ID_TEM = 10000000

const CambioPrecio = ({
  idPublicacion,
  value: precioUnitario,
  monedaSimbolo,
  onChangeState,
  onChangePorcentaje,
  isDisabled,
  alicuota,
  precioMayorista,
  cantDisponible,
  onChange
}) => {
  const [id, setId] = useState(0)
  const [precioOriginal, setPrecioOriginal] = useState(0)
  const [porcCambio, setPorcCambio] = useState(0)
  const [importeCambio, setImporteCambio] = useState(0)
  const [cantidadDisponibleCambio, setCantidadDisponibleCambio] = useState(0)
  const [preciosMayorista, setPreciosMayorista] = useState([])
  const [unidades, setUnidades] = useState([])

  const handleChangePorcentaje = (e) => {
    const porcCambio = e.target.value
    let valor = isNaN(porcCambio) || porcCambio === '' ? 0 : parseFloat(porcCambio)
    if (valor < 0) {
      valor = 0
    }
    if (valor > MAX_PORC_CAMBIO) {
      valor = MAX_PORC_CAMBIO
    }
    setPorcCambio(valor)
    setImporteCambio(precioOriginal)
    const nuevoPrecio =
      valor === 0 ? precioOriginal : precioOriginal + (valor * precioOriginal) / 100
    onChangeState('precioUnitario', nuevoPrecio)
    onChange(e, 'calc', e.target.value)
  }

  const handleChangeImporte = (e) => {
    const importe = e.target.value
    let nuevoPrecio = isNaN(importe) || importe === '' ? precioOriginal : parseFloat(importe)
    if (nuevoPrecio <= 0) {
      nuevoPrecio = precioOriginal
    }
    setImporteCambio(nuevoPrecio)
    setPorcCambio(0)
    onChangeState('precioUnitario', nuevoPrecio)
    onChange(e, 'calc', e.target.value)
  }

  const handleChangeCantidadDisponible = (e) => {
    const cantidad = e.target.value
    const nuevaCantidad = Number(cantidad) === '' ? cantDisponible : cantidad
    setCantidadDisponibleCambio(nuevaCantidad)
    onChangeState('cantDisponible', nuevaCantidad)
    onChange(e, 'calc', e.target.value)
  }

  useEffect(() => {
    if (idPublicacion !== id || (precioOriginal === 0 && precioUnitario !== undefined)) {
      setId(idPublicacion)
      setPorcCambio(0)
      if (precioUnitario !== undefined) {
        setPrecioOriginal(precioUnitario)
        setImporteCambio(precioUnitario)
      } else {
        setImporteCambio(0)
      }
      setCantidadDisponibleCambio(Number(cantDisponible) || 0)
    }
  }, [idPublicacion, id, precioOriginal, precioUnitario, cantDisponible, onChangePorcentaje])

  const buscarUnidades = async () => {
    const unidadesRtn = await buscarUnidad()
    setUnidades(unidadesRtn.data)
  }

  useEffect(() => {
    unidades.length === 0 && buscarUnidades()
    setPreciosMayorista(precioMayorista)
  }, [precioMayorista])

  let disabled
  if (isDisabled) {
    disabled = 'disabled'
  }
  const handleChangeAlicuota = (alicuota) => {
    onChangeState('alicuota', isNaN(alicuota) || alicuota === '' ? 0 : parseFloat(alicuota))
  }

  const onChangeMayorista = ({ target }, idPublicacionPrecioMayorista) => {
    const { value, name } = target
    const valueInt = parseInt(value)
    let precios
    if (precioMayorista.length === 1) {
      precios = [{ ...precioMayorista[0], [name]: valueInt > 0 ? valueInt : 0 }]
    } else {
      precios = preciosMayorista.map((element) => {
        return element.idPublicacionPrecioMayorista === idPublicacionPrecioMayorista
          ? {
              ...element,
              [name]: valueInt > 0 ? valueInt : 0
            }
          : element
      })
    }
    onChangeState('preciosMayorista', precios)
    setPreciosMayorista(precios)

    onChange(
      {
        currentTarget: {
          name: 'preciosMayorista',
          value: precios
        }
      },
      'calc',
      precios
    )
  }

  const agregarPrecioMayorista = () => {
    const primeraUnidad = preciosMayorista && preciosMayorista.length > 0 ? preciosMayorista[0] : {}

    const nuevo = {
      idPublicacionPrecioMayorista: Math.floor(Math.random() * PRECIO_MAYORISTA_ID_TEM),
      idPublicacion: 0,
      cantidad: 0,
      precio: 0,
      idUnidadMedida: primeraUnidad.idUnidadMedida ?? null,
      unidad: primeraUnidad.unidad ?? ''
    }

    const nuevos = [...preciosMayorista, nuevo]

    setPreciosMayorista(nuevos)
    onChangeState('preciosMayorista', nuevos)
  }

  const eliminarPrecioMayorista = (idPublicacionPrecioMayorista) => {
    const nuevos = preciosMayorista.filter(
      (fila) => fila.idPublicacionPrecioMayorista !== idPublicacionPrecioMayorista
    )
    setPreciosMayorista(nuevos)
    onChangeState('preciosMayorista', nuevos)
  }

  return (
    <div className="d-flex align-items-center flex-wrap gap-5">
      <div className="d-flex align-items-center me-4">
        <span className="me-2">Por porcentaje</span>
        <Input
          type="number"
          name="porcCambio"
          value={porcCambio}
          onChange={(e) => handleChangePorcentaje(e)}
          className="input-text-bordered"
          disabled={disabled}
          style={{ width: '80px' }}
        />
        <i className="fa fa-percent ms-1" aria-hidden="true" />
      </div>
      <div className="d-flex align-items-center me-4">
        <span className="me-2">Por Importe</span>
        <i className="fa fa-dollar me-1" aria-hidden="true" />
        <Input
          type="number"
          name="importeCambio"
          value={importeCambio}
          onChange={(e) => handleChangeImporte(e)}
          className="input-text-bordered"
          disabled={disabled}
          style={{ width: '100px' }}
        />
      </div>
      <div className="d-flex align-items-center me-4">
        <span className="me-2">Alicuota</span>
        <Input
          type="number"
          name="alicuota"
          value={alicuota}
          onChange={(e) => (
            handleChangeAlicuota(e.target.value),
            onChange(e, 'calc', e.target.value)
          )}
          className="input-text-bordered"
          disabled={disabled}
          step="0.1"
          style={{ width: '80px' }}
        />
      </div>
      <div className="d-flex align-items-center me-4">
        <InputLabel
          type="number"
          name="cantDisponible"
          value={cantidadDisponibleCambio}
          onChange={(e) => handleChangeCantidadDisponible(e)}
          label="Cantidad Disponible:"
          classNameInput="publicacion-precio w-10"
          classNameLabel="mr-2"
          onFocusSelected
        />
      </div>
      <div className="d-block">{formatearMonto(precioUnitario, monedaSimbolo)}</div>
      <div>
        <div className="d-block mt-2 mb-2 font-weight-bold ">Precio mayorista</div>
        <button className="btn btn-primary mb-3" type="button" onClick={agregarPrecioMayorista}>
          + Agregar precio mayorista
        </button>
        {preciosMayorista?.length > 0 &&
          preciosMayorista.map((mayorista, index) => (
            <div className="row mb-2 g-2 align-items-end" key={index}>
              <div className="col-auto d-flex align-items-center">
                <InputLabel
                  type="number"
                  name="cantidad"
                  label="Cantidad"
                  classNameLabel="mr-2"
                  value={mayorista?.cantidad || 0}
                  onChange={(e) => onChangeMayorista(e, mayorista.idPublicacionPrecioMayorista)}
                  classNameInput="input-text-bordered w-40"
                  error="Completar Precio Mayorista Cantidad"
                  onFocusSelected
                />
              </div>
              <div className="col-auto d-flex align-items-center">
                <InputLabel
                  type="number"
                  name="precio"
                  label="Precio Unitario"
                  classNameLabel="mr-2"
                  value={mayorista.precio || 0}
                  onChange={(e) => onChangeMayorista(e, mayorista.idPublicacionPrecioMayorista)}
                  classNameInput="input-text-bordered w-40"
                  error="Completar Precio Mayorista Unitario"
                  onFocusSelected
                />
              </div>
              <div className="col-auto d-flex align-items-center">
                <span className=" mr-2"> Unidad: </span>
                <GenericSelect
                  name="idUnidadMedida"
                  value={mayorista.idUnidadMedida || 0}
                  onChange={(value) =>
                    onChangeMayorista(
                      { target: { name: 'idUnidadMedida', value } },
                      mayorista.idPublicacionPrecioMayorista
                    )
                  }
                  options={unidades.map((unidad) => ({
                    value: unidad.idUnidadMedida,
                    label: unidad.nombre
                  }))}
                  placeholder="Seleccionar"
                />
              </div>
              <div className="col-auto">
                <button
                  type="button"
                  title="Eliminar precio mayorista"
                  className={`${styles.btn} btn-danger`}
                  onClick={() => eliminarPrecioMayorista(mayorista.idPublicacionPrecioMayorista)}
                >
                  <i className="bi bi-trash" />
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

CambioPrecio.propTypes = {
  idPublicacion: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  monedaSimbolo: PropTypes.string.isRequired,
  onChangeState: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangePorcentaje: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  alicuota: PropTypes.number.isRequired,
  cantDisponible: PropTypes.number.isRequired,
  precioMayorista: PropTypes.arrayOf(
    PropTypes.shape({
      cantidad: PropTypes.number.isRequired,
      precio: PropTypes.number.isRequired,
      unidad: PropTypes.string.isRequired
    })
  )
}

export default CambioPrecio
